import { FC } from 'react';
import { ENV_CONFIG } from 'config/environment';
import Spacing from 'components/Spacing';
import LottieStory from 'components/LottieElements/Story';
import { Container, MotionText, StyledImage } from './styled';
import { CURRENT_CYCLE_YEAR } from 'screens/Profile/utils';

interface Props {
  isPaused: boolean;
  isCommunityReportReady: boolean;
}

export const NoImpactReport: FC<Props> = ({ isPaused, isCommunityReportReady }) => {
  return (
    <LottieStory slide="orbs" isPaused={isPaused}>
      <Container>
        <MotionText $size={15}>
          {`It looks like we don't have any donations for the ${CURRENT_CYCLE_YEAR - 1}-${CURRENT_CYCLE_YEAR} cycle under this account.`}
        </MotionText>
        <Spacing $size={24} />
        <MotionText $size={15}>
          If you made donations with another email, log in under that email to view your Impact
          Report.
        </MotionText>
        <Spacing $size={24} />
        {isCommunityReportReady && (
          <MotionText $size={15}>
            {`If you're new here, please check out Oath's ${CURRENT_CYCLE_YEAR} Community Impact Report. We're excited to
          have you onboard!`}
          </MotionText>
        )}
        <StyledImage
          alt="Oath logo"
          src={`${
            ENV_CONFIG().CLOUD_STORAGE.URL
          }/static_content/oath_logos/Oath_FullLockup_Color_LightText.svg`}
        />
      </Container>
    </LottieStory>
  );
};
